module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade modal-print-vp",
    attrs: {
      "id": "modal-print-vp",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "modal-print-vp-label"
    },
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.closeModal()
      }
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.closeModal()
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), (_vm.errorMessage) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_c('p', [_vm._v(_vm._s(_vm.errorMessage))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "vp-info"
  }, [_c('h4', [_vm._v("\n            N° Vale-pedágio:\n            "), _c('span', [_vm._v(_vm._s(_vm.vpSelected.idProtocolo))])]), _vm._v(" "), _c('h4', [_vm._v("\n            Valor:\n            "), _c('span', [_vm._v(_vm._s(_vm._f("cents")(_vm.vpSelected.valorVP)))])]), _vm._v(" "), _c('p', [_vm._v("\n            Transportador:\n            "), _c('span', [_vm._v(_vm._s(_vm.vpSelected.transportador))])]), _vm._v(" "), _c('p', {
    staticClass: "inline"
  }, [_vm._v("\n            N° TAG:\n            "), _c('span', [_vm._v(_vm._s(_vm.vpSelected.tag))])]), _vm._v(" "), _c('p', {
    staticClass: "inline"
  }, [_vm._v("\n            Placa:\n            "), _c('span', {
    staticClass: "upper"
  }, [_vm._v(_vm._s(_vm.vpSelected.placaVeiculo))])])]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "icon-circle-right"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', [_vm._v("Escolha o formato do arquivo para exportação.")]), _vm._v(" "), _c('div', {
    staticClass: "btn-group"
  }, [_c('div', {
    staticClass: "btn-group",
    attrs: {
      "data-toggle": "buttons"
    }
  }, [_c('label', {
    staticClass: "btn",
    class: {
      'active': _vm.downloadType == 'pdf'
    },
    on: {
      "click": function($event) {
        _vm.downloadType = 'pdf'
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.downloadType),
      expression: "downloadType"
    }],
    attrs: {
      "type": "radio",
      "name": "options",
      "id": "pdf",
      "value": "pdf",
      "checked": ""
    },
    domProps: {
      "checked": _vm.downloadType == 'pdf',
      "checked": _vm._q(_vm.downloadType, "pdf")
    },
    on: {
      "change": function($event) {
        _vm.downloadType = "pdf"
      }
    }
  }), _vm._v(" PDF\n              ")]), _vm._v(" "), _c('label', {
    staticClass: "btn",
    class: {
      'active': _vm.downloadType == 'xlsx'
    },
    on: {
      "click": function($event) {
        _vm.downloadType = 'xlsx'
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.downloadType),
      expression: "downloadType"
    }],
    attrs: {
      "type": "radio",
      "name": "options",
      "id": "xlsx",
      "value": "xlsx"
    },
    domProps: {
      "checked": _vm.downloadType == 'xlsx',
      "checked": _vm._q(_vm.downloadType, "xlsx")
    },
    on: {
      "change": function($event) {
        _vm.downloadType = "xlsx"
      }
    }
  }), _vm._v(" EXCEL\n              ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "no-btn",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.closeModal()
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.download(_vm.vpSelected.idIntern)
      }
    }
  }, [_vm._v("\n          Exportar\n          "), _c('i', {
    staticClass: "icon-circle-right"
  })])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('span', [_vm._v(".pdf")]), _vm._v(" "), _c('span', [_vm._v(".xlsx")])])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-86cbe212!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/account/aggregate/modal/modal-print-vp.vue
// module id = 2189
// module chunks = 1